import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, IconButton } from '@material-ui/core';
import VerifiedUserRoundedIcon from '@material-ui/icons/VerifiedUserRounded';
import NotInterestedRoundedIcon from '@material-ui/icons/NotInterestedRounded';
import CheckBoxOutlineBlankRoundedIcon from '@material-ui/icons/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';

const useStyles = makeStyles((theme) => ({
  memberCard: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    backgroundColor: '#eee',
    fontSize: '0.9rem',
    fontWeight: '600',
    textAlign: 'left',
    width: '100%',
  },
  memberTitle: {
    borderBottom: '1px solid #fff',
    fontSize: '1.2rem',
    margin: theme.spacing(0, 0, 1),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  memberTitleDesc: {
    color: '#888',
    fontSize: '0.8rem',
  },
  memberInfo: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
}));

const MemberCard = (props) => {
  const { member, selectMember, cancelMember, isSelected } = props;
  const classes = useStyles();

  const handleClickSelectMember = () => {
    if (isSelected) {
      cancelMember();
    } else {
      selectMember(member);
    }
  };

  return (
    <div className={classes.memberCard}>
      <div className={classes.memberTitle}>
        <div>
          {member.realName}
          <div className={classes.memberTitleDesc}>ID {member.id}</div>
        </div>
        <div>
          <Chip
            label={member.status === 2 ? '已啟用' : '未啟用'}
            color={member.status === 2 ? 'default' : 'secondary'}
            icon={
              member.status === 2 ? (
                <VerifiedUserRoundedIcon />
              ) : (
                <NotInterestedRoundedIcon />
              )
            }
            size="small"
            variant="outlined"
          />
          {cancelMember && selectMember && (
            <IconButton color="primary" onClick={handleClickSelectMember}>
              {isSelected && <CheckBoxRoundedIcon />}
              {!isSelected && <CheckBoxOutlineBlankRoundedIcon />}
            </IconButton>
          )}
        </div>
      </div>
      <div className={classes.memberInfo}>
        <div>
          <div>手機</div>
          <div>{member.cellPhone}</div>
        </div>
        <div>
          <div>Email</div>
          <div>{member.email}</div>
        </div>
      </div>
    </div>
  );
};

export default MemberCard;
